/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { Toast } from "primereact/toast";
import { accessAPI } from "../../../shared";

/**
 * Qué puede leer el script, en chips que se copian al hacer click.
 *
 * La lista la sirve la API desde el mismo archivo que arma el payload, así que
 * lo que se ofrece acá es exactamente lo que el script va a recibir. Escribirla
 * a mano en el front la dejaría desactualizada en el primer cambio de contrato.
 *
 * Mismo gesto que los campos de una comunicación de evento: click para copiar.
 */
export default function CamposDelScript({ tipo }) {
  const [campos, setCampos] = useState(null);
  const [puedenSerNull, setPuedenSerNull] = useState([]);
  const toast = useRef(null);

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/config/numeracion/campos",
      null,
      (respuesta) => {
        setCampos(respuesta.campos);
        setPuedenSerNull(respuesta.puedenSerNull || []);
      },
      () => setCampos({})
    );
  }, []);

  function copiar(texto) {
    navigator.clipboard.writeText(texto);
    toast.current?.show({
      severity: "success",
      summary: "Copiado",
      detail: `${texto} copiado al portapapeles`,
      life: 2000
    });
  }

  const disponibles = campos?.[tipo] || [];
  if (disponibles.length === 0) return null;

  const chip = (texto) => (
    <span
      key={texto}
      onClick={() => copiar(texto)}
      css={{
        backgroundColor: "var(--surface-100)",
        border: "1px solid var(--surface-300)",
        borderRadius: "4px",
        padding: "0.2em 0.5em",
        fontSize: "0.85em",
        fontFamily: "monospace",
        cursor: "pointer",
        "&:hover": { backgroundColor: "var(--surface-200)" }
      }}
    >
      {texto}
    </span>
  );

  return (
    <div css={{ marginBottom: "1.5em" }}>
      <Toast ref={toast} position="top-center" />

      <p
        css={{
          margin: "0 0 0.3em 0",
          color: "var(--grisTextos)",
          fontSize: "0.9em"
        }}
      >
        El script devuelve el nombre con <code>return</code>. Campos disponibles,
        click para copiar:
      </p>
      <div css={{ display: "flex", flexWrap: "wrap", gap: "0.4em" }}>
        {disponibles.map(chip)}
      </div>

      <p
        css={{
          margin: "0.8em 0 0.3em 0",
          color: "var(--grisTextos)",
          fontSize: "0.9em"
        }}
      >
        Para numerar de forma correlativa, <code>contador(clave)</code> devuelve el
        próximo número de esa clave y la crea si no existía. Una clave con el año
        adentro reinicia sola cada enero. Los valores se administran en Contadores.
      </p>
      <div css={{ display: "flex", flexWrap: "wrap", gap: "0.4em" }}>
        {chip("contador('procesos-' + datos.fecha.anio)")}
      </div>

      {puedenSerNull.length > 0 && (
        <p
          css={{
            margin: "0.8em 0 0 0",
            color: "var(--grisTextos)",
            fontSize: "0.85em"
          }}
        >
          {puedenSerNull.join(" y ")} llegan vacíos si el tipo de certificado no
          los tiene asignados.
        </p>
      )}
    </div>
  );
}
